import { Icon } from "@iconify/react/dist/iconify.js";
import React, {
  useEffect,
  useRef,
  useState,
  createContext,
  useContext,
  useMemo,
} from "react";

import { FaCaretDown } from "react-icons/fa";
import { FiX } from "react-icons/fi";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import calllogo from "../Assets/phone-call.png";
import CalendarLogo from "../Assets/calendar123.png";
import { AlertTriangle } from "lucide-react";
import DumImg from "../Assets/userDum.webp";
import {
  formatDateStringdot,
  handleError,
  handleLinkClick,
  handleSuccess,
} from "../CommonJquery/CommonJquery";
import "../components/CSS/Header.css";
import {
  removeData,
  retrieveData,
  storeData,
} from "../LocalConnection/LocalConnection";
import {
  firebase_notification,
  pre_pay_payment,
  custom_open_close_reviews,
  server_post_data,
  logout_user,
} from "../ServiceConnection/serviceconnection";
import { ArrowUpCircle } from "lucide-react";
import wowLogo from "../Assets/newLogo.png";
import wowRevFooter from "../Assets/wowRevFooter.png";
import wowMgnifyImg from "../Assets/wowMgnifyImg.png";
import Modal from "react-bootstrap/Modal";
import electricIcon from "../Assets/electricIcon.svg";
import goodmarkImg from "../Assets/goodmarkImg.svg";
import { X } from "lucide-react";
import plan1 from "../Assets/plan1.png";
import plan2 from "../Assets/plan2.png";
import plan3 from "../Assets/plan3.png";
const MasterDataContext = createContext();

export const useMasterData = () => {
  const context = useContext(MasterDataContext);
  if (!context) {
    throw new Error("useMasterData must be used within MasterLayout");
  }
  return context;
};
const MasterLayout = ({ children }) => {
  const notiBarRef = useRef(null);
  const final_full_name = retrieveData("final_full_name");
  const user_image_path = retrieveData("user_image_path");
  const user_image = retrieveData("user_image");
  let final_bus_id = retrieveData("final_bus_id");
  const [sidebarActive, seSidebarActive] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [notiBar, setNotiBar] = useState(false);
  const [reviewData, setreviewData] = useState([]);
  const [ticketData, setticketData] = useState([]);
  const [BusinessList, setBusinessList] = useState([]);
  const [businessTypes, setbusinessTypes] = useState([]);
  const [BusinessOtherSections, setBusinessOtherSections] = useState([]);
  const [MasterData, setMasterData] = useState({});

  const [DateCount, setDateCount] = useState(0);
  const location = useLocation(); // Hook to get the current route
  const [theme, setTheme] = useState(
    localStorage.getItem("custom_theme") || "light",
  );
  const [isClearing, setIsClearing] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  // 2. Function to update the theme on the HTML element
  const updateThemeOnHtmlEl = (theme) => {
    document.documentElement.setAttribute("data-theme", theme);
  };
  const [pricingPlansnew, setpricingPlansnew] = useState([]);

  const [activeTab, setActiveTab] = useState("monthly");
  const [selectedCountry, setSelectedCountry] = useState("india"); // defaul
  // 4. On initial render, set the theme from localStorage
  useEffect(() => {
    updateThemeOnHtmlEl(theme);
  }, [theme]);

  // 5. Toggle theme when button is clicked
  const handleThemeToggle = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    setTheme(newTheme);
    storeData("custom_theme", newTheme);
    updateThemeOnHtmlEl(newTheme);
  };

  const toggleNotiBar = () => {
    setNotiBar(!notiBar);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notiBarRef.current && !notiBarRef.current.contains(event.target)) {
        setNotiBar(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const [customerDesignation, setCustomerDesignation] = useState([]);

  useEffect(() => {
    if (parseInt(DateCount) >= 0) {
      // setShowModal(false);
    } else {
      // setShowModal(true);
      if (
        window.location.pathname === "/Support" ||
        window.location.pathname === "/subscription" ||
        window.location.pathname === "/profile"
      ) {
        console.log("You are on an allowed page");
      } else {
        navigate("/subscription-expired");
      }
    }
  }, [DateCount]);

  useEffect(() => {
    const retrivemsg = retrieveData("session_msg");

    if (
      retrivemsg !== "" &&
      retrivemsg !== null &&
      retrivemsg !== "0" &&
      retrivemsg !== "1"
    ) {
      handleSuccess(retrivemsg, 1);
    }

    if (final_full_name === "0") {
      handleLinkClick("/sign-in");
    }
    if (final_bus_id === "0") {
      handleLinkClick("/sign-in");
    }
  }, []);

  // Function to detect user's country
  const detectUserCountry = async () => {
    try {
      const response = await fetch("https://ipapi.co/json/");
      const data = await response.json();
      const country = data.country_code === "IN" ? "india" : "usa";
      setSelectedCountry(country);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const initialize = async () => {
      await detectUserCountry(); // wait for country detection
    };
    initialize();
  }, []);

  useEffect(() => {
    if (selectedCountry) {
      master_data_get(); // only call this once selectedCountry is set
    }
  }, [selectedCountry, activeTab]);
  const planImages = {
    "plan1.svg": plan1,
    "plan2.svg": plan2,
    "plan3.svg": plan3,
  };
  const master_data_get = async (flag) => {
    var formdata = new FormData();
    formdata.append("clear_or_not", flag);
    await server_post_data(firebase_notification, formdata)
      .then((Response) => {
        let data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        if (parseInt(data[0]) === 1) {
          handleError(final_data.message);
        } else {
          setCustomerDesignation(final_data.geti || []);
          setBusinessList(final_data.total_business_list || []);
          setreviewData(final_data.get_list_review || []);
          setticketData(final_data.get_ticket_list || []);
          setBusinessOtherSections(final_data.business_other_sections[0] || []);
          setMasterData(final_data);

          const selectedPlanAmount = parseFloat(
            retrieveData("price_amount_package"),
          );
          const formattedSelectedPlan =
            selectedPlanAmount % 1 === 0
              ? selectedPlanAmount.toFixed(0)
              : selectedPlanAmount.toFixed(2);

          const updatedPlans = final_data.price_data.map((plan) => {
            if (!plan.pricing) return plan;

            const pricingInfo = plan.pricing[selectedCountry]?.[activeTab];
            if (!pricingInfo) return plan;

            const strippedPrice = pricingInfo.price.replace(/[^0-9.]/g, "");
            const isSelected = strippedPrice === formattedSelectedPlan;

            const selectedplanTrail =
              final_data.total_business_list?.find(
                (item) => item.bus_id === final_bus_id,
              )?.trail_or_no || null;

            return {
              ...plan,
              price: pricingInfo.price,
              id_add: pricingInfo.id_add,
              buttonText:
                selectedplanTrail === "1"
                  ? isSelected
                    ? "Buy Now"
                    : "Upgrade Now"
                  : isSelected
                    ? "Current Plan"
                    : "Upgrade Now",
              isSelected, // ✅ Custom flag added
            };
          });
          setpricingPlansnew(updatedPlans);
          setbusinessTypes(final_data.user_data);
          setDateCount(getDaysUntil(final_data.user_data.end_date));
          setSelectedOption(
            final_data.total_business_list?.find(
              (item) => item.bus_id === parseInt(final_bus_id),
            )?.business_name || null,
          );
        }
        if (flag === 1) {
          setIsClearing(false);
        }
      })
      .catch((error) => {
        removeData();
        console.log(error);
        handleError("network");
      });
  };

  const getDaysUntil = (date_get) => {
    const today = new Date(); // Current date
    const target = new Date(date_get); // Target date

    // Reset time to midnight for clean day difference
    today.setHours(0, 0, 0, 0);
    target.setHours(0, 0, 0, 0);

    const diffTime = target.getTime() - today.getTime(); // Difference in milliseconds
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // Convert to days

    return diffDays;
  };
  useEffect(() => {
    // Function to handle dropdown clicks
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      // Close all dropdowns
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
      });

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add("open");
      }
    };

    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link",
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    // Function to open submenu based on current route
    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
          }
        });
      });
    };

    // Open the submenu that contains the open route
    openActiveDropdown();

    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };
  /**-------Drop down --------- */
  const dropdownRef = useRef(null);
  const [showDate, SetShowDate] = useState(false);
  const [selectedOption, setSelectedOption] = useState(
    "Select Business Option",
  );
  const [searchTerm, setSearchTerm] = useState("");
  const handleSHowdate = () => {
    SetShowDate(!showDate);
  };
  const handleSelectOption = (option) => {
    setSelectedOption(option.business_name);
    setSearchTerm("");
    storeData("counter_bus_id", option.bus_counter);
    storeData("final_bus_id", option.bus_id);
    final_bus_id = option.bus_id;
    handleLinkClick("/");
    SetShowDate(false);
  };
  const filteredBusinessList = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();

    if (!term) return BusinessList;

    return (BusinessList || []).filter((item) =>
      (item.business_name || "").toLowerCase().includes(term),
    );
  }, [BusinessList, searchTerm]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        SetShowDate(false);
      }
    };
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleLogoutClick = async () => {
    await server_post_data(logout_user, null)
      .then((Response) => {
        let data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        if (parseInt(data[0]) === 1) {
          handleError(final_data.message);
        } else {
          removeData();
        }
      })
      .catch((error) => {
        console.log(error);
        handleError("network");
      });
  };
  const clearNotifications = () => {
    setIsClearing(true);
    master_data_get(1);
  };

  ///---------------pricing Modal--------------
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  const openModalPricing = () => {
    setShowModal(!showModal);
  };
  const closeModal = () => {
    setShowModal(false);
  };

  const handleNavigate = () => {
    navigate("https://www.wowreviews.co/Home/contact_us", { target: "_blank" });
  };

  const handlepayment = async (plan) => {
    const hasErrors = false;
    if (!hasErrors) {
      setIsLoading(true);
      let fd_from = new FormData();
      fd_from.append("id_add", plan.id_add);
      fd_from.append("flag", "1");
      await server_post_data(pre_pay_payment, fd_from)
        .then((Response) => {
          setIsLoading(false);
          let data1 = Response.message.split("~@~");
          if (parseInt(data1[0]) === 1) {
            handleError(data1[1]);
          } else {
            const chargebeeCheckoutUrl = data1[1];
            // Redirect to Chargebee checkout page
            window.location.href = chargebeeCheckoutUrl;
          }
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  const isWithinLast20Days = (date) => {
    const now = new Date();
    const entry = new Date(date);
    const diffTime = now - entry;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);
    return diffDays <= 20;
  };

  const handlenotifClick = async (notification) => {
    let formdata = new FormData();
    formdata.append("ticket_id", notification.bb_id);
    try {
      const response = await server_post_data(
        custom_open_close_reviews,
        formdata,
      );
      const data1 = response.message.split("~@~");
      if (parseInt(data1[0]) === 1) {
        handleError(data1[1]);
      }
    } catch (error) {
      console.error("Error in master_update_open:", error);
    }
  };

  const reviewDataCount =
    reviewData?.filter((item) => isWithinLast20Days(item.entry_date)).length ||
    0;
  const designationCount =
    customerDesignation?.filter((item) => isWithinLast20Days(item.entry_date))
      .length || 0;
  const ticketDataCount =
    ticketData?.filter((item) => isWithinLast20Days(item.entry_date)).length ||
    0;

  const totalCount = reviewDataCount + designationCount + ticketDataCount;

  return (
    <MasterDataContext.Provider
      value={{
        MasterData, // the full object from API
        showEmailForm: MasterData?.user_data?.show_email_form ?? "0", // ← the value you need
        BusinessList,
        reviewData,
        ticketData,
        pricingPlansnew,
        DateCount,
        // add any other values you want to share
      }}
    >
      <section
        className={mobileMenu ? "overlay active" : "overlay "}
        style={{ overflow: "hidden" }}
      >
        {/* sidebar */}
        <aside
          className={
            sidebarActive
              ? "sidebar active "
              : mobileMenu
                ? "sidebar sidebar-open"
                : "sidebar"
          }
        >
          <button
            onClick={mobileMenuControl}
            type="button"
            className="sidebar-close-btn"
          >
            <Icon icon="radix-icons:cross-2" />
          </button>
          <div>
            <Link to="/" className="sidebar-logo">
              <img
                src={wowLogo}
                alt="site logo"
                className="light-logo logo12"
              />
              <img
                src={wowRevFooter}
                alt="site logo"
                className="dark-logo logo12"
              />
              <img src={wowMgnifyImg} alt="site logo" className="logo-icon" />
            </Link>
          </div>
          <div className="sidebar-menu-area">
            <ul className="sidebar-menu" id="sidebar-menu">
              <li className="">
                <NavLink
                  to="/"
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon
                    icon="solar:home-smile-angle-outline"
                    className="menu-icon"
                  />
                  <span>Dashboard</span>
                </NavLink>
              </li>

              <li className="sidebar-menu-group-title">Review Mangment</li>

              <li>
                <NavLink
                  to="/Reviews"
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="bi:chat-dots" className="menu-icon" />
                  <span>Reviews</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/crm"
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="hugeicons:invoice-03" className="menu-icon" />
                  <span>CRM</span>
                </NavLink>
              </li>

              {/* <li>
              <NavLink
                to="/event_listning"
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon="mingcute:storage-line" className="menu-icon" />
                <span>Advertisement</span>
              </NavLink>
            </li> */}
              <li>
                <NavLink
                  to="/summaryreport"
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon
                    icon="mdi:file-document-outline"
                    className="menu-icon"
                  />
                  <span>Repo Auditor</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/annual_report"
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="mdi:chart-bar" className="menu-icon" />
                  <span>AI Report</span>
                </NavLink>
              </li>
              {/* <li className="sidebar-menu-group-title">GMB Mangment</li>

            <li>
              <NavLink
                to="/gmb_overview"
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon="bi:chat-dots" className="menu-icon" />
                <span>Overview</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/content_updates"
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon="hugeicons:invoice-03" className="menu-icon" />
                <span>Content Updates</span>
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/keyword_positions"
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon="mingcute:storage-line" className="menu-icon" />
                <span>Keyword Positions</span>
              </NavLink>
            </li> */}
              {parseInt(BusinessOtherSections?.menu_section) === 0 && (
                <>
                  <li className="sidebar-menu-group-title">Menu Managment</li>
                  <li>
                    <NavLink
                      to="/Menu-management"
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <Icon icon="mdi:menu" className="menu-icon" />
                      <span>Menu</span>
                    </NavLink>
                  </li>
                </>
              )}

              <li className="sidebar-menu-group-title">Social Media</li>

              {/* <li>
                <NavLink
                  to="/social-dashboard"
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon
                    icon="mdi:view-dashboard-outline"
                    className="menu-icon"
                  />
                  <span>Social Dashboard</span>
                </NavLink>
              </li> */}
              <li>
                <NavLink
                  to="/gmb_overview"
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="mdi:google" className="menu-icon" />
                  <span>GMB Manager</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/fb_overview"
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="mdi:facebook" className="menu-icon" />
                  <span>Facebook</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/instagram_overview"
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="mdi:instagram" className="menu-icon" />
                  <span>Instagram</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/threads_overview"
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="ri:threads-fill" className="menu-icon" />
                  <span>Threads</span>
                </NavLink>
              </li>
              {/* <li>
                <NavLink
                  to="/linkedin_overview"
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="mdi:linkedin" className="menu-icon" />
                  <span>LinkedIn</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/twitter_overview"
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="ri:twitter-x-fill" className="menu-icon" />
                  <span>X / Twitter</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/tiktok_overview"
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="ic:baseline-tiktok" className="menu-icon" />
                  <span>TikTok</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/pinterest_overview"
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="mdi:pinterest" className="menu-icon" />
                  <span>Pinterest</span>
                </NavLink>
              </li>
             */}

              <li className="sidebar-menu-group-title">Configuration</li>
              <li>
                <NavLink
                  to="/ManageQRcode"
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="mdi:qrcode" className="menu-icon" />
                  <span> Manage QR</span>
                </NavLink>
              </li>
              {/* <li className="sidebar-menu-group-title">Configuration</li> */}
              <li>
                <NavLink
                  to="/Setup-Review-Channels"
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="mdi:radio-tower" className="menu-icon" />
                  <span>Setup Channels</span>
                </NavLink>
              </li>
              {/* <li>
              <NavLink
                to="/Setup-Review-Channels"
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon="mdi:radio-tower" className="menu-icon" />
                <span>Setup GMB</span>
              </NavLink>
            </li> */}

              <li className="sidebar-menu-group-title">Account Managment</li>

              {/* Settings Dropdown */}
              <li className="dropdown mt-1">
                <Link to="#">
                  <Icon
                    icon="icon-park-outline:setting-two"
                    className="menu-icon"
                  />
                  <span>Settings</span>
                </Link>
                <ul className="sidebar-submenu">
                  {/* <li>
                  <NavLink
                    to="/notification"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                    style={{ gap: "0" }}
                  >
                    <Icon
                      icon="flowbite:users-group-outline"
                      className="menu-icon"
                    />
                    Staff Manegment
                  </NavLink>
                </li> */}
                  <li>
                    <NavLink
                      to="/profile"
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className="ri-user-settings-line" />
                      <span>Profile</span>
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      to="/subscription"
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                      style={{ gap: "0" }}
                    >
                      <Icon
                        icon="heroicons:document-text"
                        className="menu-icon"
                      />
                      Subs. & Billing
                    </NavLink>
                  </li>
                  {/* <li>
                  <NavLink
                    to="/reports"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                    style={{ gap: "0" }}
                  >
                    <Icon icon="heroicons:document" className="menu-icon" />
                    Reports
                  </NavLink>
                </li> */}
                  <li>
                    <NavLink
                      to="/Support"
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                      style={{ gap: "0" }}
                    >
                      <Icon
                        icon="mage:message-question-mark-round"
                        className="menu-icon"
                      />
                      Support
                    </NavLink>
                  </li>
                </ul>
              </li>

              {/* {DateCount && DateCount < 20 && (
              <button
                type="button"
                className="upgrade_package_bttn"
                onClick={openModalPricing}
              >
                <ArrowUpCircle
                  size={20}
                  style={{ marginRight: "0.5rem", verticalAlign: "middle" }}
                  className="menu-icon"
                />
                Upgrade
              </button>
            )} */}

              {DateCount && DateCount < 20 && (
                <li>
                  <NavLink
                    onClick={openModalPricing}
                    className={(navData) =>
                      navData.isActive ? "upgrade_package_bttn " : " "
                    }
                  >
                    <ArrowUpCircle size={20} className="menu-icon" />
                    <span>Upgrade</span>
                  </NavLink>
                </li>
              )}
              <li className="mt-20 hideTill600">
                <a className="Call-support" href="tel:7880016622">
                  <img
                    src={calllogo}
                    alt="Call Support"
                    className="w-20-px h-20-px object-fit-cover rounded-circle"
                  />
                  <div style={{ marginLeft: "10px" }}>
                    <p style={{ fontSize: "14px" }}>Call for Support</p>
                    <p style={{ fontSize: "14px", fontWeight: "600" }}>
                      7880016622
                    </p>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </aside>

        <main
          className={sidebarActive ? "dashboard-main active" : "dashboard-main"}
          style={{ overflowY: "hidden", height: "100vh" }}
        >
          <div className="navbar-header">
            <div className="row align-items-center justify-content-between gapTop">
              <div className="col-auto">
                <div className="d-flex flex-wrap align-items-center gap-4">
                  <button
                    type="button"
                    className="sidebar-toggle"
                    onClick={sidebarControl}
                  >
                    {sidebarActive ? (
                      <Icon
                        icon="iconoir:arrow-right"
                        className="icon text-2xl non-active"
                      />
                    ) : (
                      <Icon
                        icon="heroicons:bars-3-solid"
                        className="icon text-2xl non-active "
                      />
                    )}
                  </button>
                  <button
                    onClick={mobileMenuControl}
                    type="button"
                    className="sidebar-mobile-toggle"
                  >
                    <Icon icon="heroicons:bars-3-solid" className="icon" />
                  </button>
                </div>
              </div>
              <div className="col-auto padding0after400">
                <div className="d-flex flex-wrap align-items-center gapNewMob gap-3">
                  {DateCount && DateCount < 20 && (
                    // <div
                    //   className={`sub_ending_container `}
                    //   onClick={openModalPricing}
                    // >
                    //   <div className="sub_ending_txt">
                    //     <div className="icon_wrapper">
                    //       <Clock
                    //         size={17}
                    //         className="clock_icon_subscription_end"
                    //       />
                    //     </div>
                    //     <div className="text_content">
                    //       <p className="heading">Subscription Ending</p>
                    //       <span className="days_left">
                    //         Only {DateCount} days left
                    //       </span>
                    //     </div>
                    //   </div>
                    // </div>
                    <a
                      className="Call-support hideAfter600"
                      onClick={openModalPricing}
                    >
                      <img
                        src={CalendarLogo}
                        alt="Call Support"
                        className="w-20-px h-20-px object-fit-cover rounded-circle"
                      />
                      <div style={{ marginLeft: "10px" }}>
                        <p style={{ fontSize: "10px" }}>Subscription Ending</p>
                        <p style={{ fontSize: "10px", fontWeight: "600" }}>
                          Only{" "}
                          <span className="days_left">{DateCount} days</span>{" "}
                          left
                        </p>
                      </div>
                    </a>
                  )}

                  <a
                    className="Call-support hideAfter600"
                    href="tel:7880016622"
                  >
                    <img
                      src={calllogo}
                      alt="Call Support"
                      className="w-20-px h-20-px object-fit-cover rounded-circle"
                    />
                    <div style={{ marginLeft: "10px" }}>
                      <p style={{ fontSize: "10px" }}>Call for Support</p>
                      <p style={{ fontSize: "10px", fontWeight: "600" }}>
                        7880016644
                      </p>
                    </div>
                  </a>
                  <div className="DropDownandsearchabr HeaderDroPDownTIme">
                    <div
                      className="dropdown position-relative"
                      ref={dropdownRef}
                    >
                      <div
                        className="SelectTimeFram"
                        onClick={() => SetShowDate((prev) => !prev)}
                      >
                        {showDate ? (
                          <input
                            type="text"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onClick={(e) => e.stopPropagation()}
                            placeholder="Search business..."
                            autoFocus
                            style={{
                              border: "none",
                              outline: "none",
                              background: "transparent",
                              width: "100%",
                              color: "#000",
                            }}
                          />
                        ) : (
                          <button type="button">
                            {selectedOption?.slice(0, 14)}...
                          </button>
                        )}
                        <FaCaretDown
                          style={{
                            transform: showDate
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                            transition: "transform 0.3s ease",
                          }}
                        />
                      </div>

                      {showDate && (
                        <div className="dataDropDownptions">
                          {filteredBusinessList.length > 0 ? (
                            filteredBusinessList.map((review, index) => (
                              <button
                                key={review.bus_id || index}
                                onClick={() => handleSelectOption(review)}
                                className={
                                  Number(final_bus_id) === Number(review.bus_id)
                                    ? "active"
                                    : ""
                                }
                              >
                                {review.business_name}
                              </button>
                            ))
                          ) : (
                            <button type="button" className="disabled">
                              No business found
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  {/* Notification dropdown end */}
                  <Link
                    className="SelectTimeFramHide"
                    onClick={() => {
                      window.location.reload();
                    }}
                  >
                    <button
                      className="has-indicator w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center"
                      type="button"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="Sync Data"
                    >
                      <Icon
                        icon="mdi:sync"
                        className="text-primary-light text-xl"
                      />
                    </button>
                  </Link>
                  {/* Message dropdown end */}
                  <button
                    className="has-indicator w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center"
                    type="button"
                    onClick={() => toggleNotiBar()}
                    style={{ position: "relative" }}
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Notifications"
                  >
                    <Icon
                      icon="iconoir:bell"
                      className="text-primary-light text-xl"
                    />

                    {reviewData?.length + (customerDesignation?.length || 0) >
                      0 && <div className="notFicationDott"></div>}
                  </button>

                  <div
                    ref={notiBarRef}
                    className={`newNotiBAr ${notiBar ? "newNotiBArSHow" : ""}`}
                  >
                    <div className="m-16 py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                      <div className="d-flex align-items-center gap-2">
                        <h6 className="text-md text-primary-light fw-semibold mb-0">
                          Notifications
                        </h6>
                        <span
                          className="text-primary-600 fw-semibold  w-32-px h-32-px rounded-circle bg-base d-flex justify-content-center align-items-center"
                          style={{ fontSize: "14px" }}
                        >
                          {totalCount}
                        </span>
                      </div>
                      <div onClick={() => toggleNotiBar()}>
                        {" "}
                        <FiX
                          className="text-primary-600 mt-2 cursor-pointer"
                          size={20}
                        />
                      </div>
                    </div>
                    <div className="h-100 overflow-y-auto scroll-sm pe-4">
                      {customerDesignation.length > 0 ||
                      reviewData.length > 0 ||
                      ticketData.length > 0 ? (
                        <>
                          {customerDesignation.length > 0 &&
                            customerDesignation.map((notification, index) => (
                              <Link
                                key={index}
                                to="#"
                                className={`notification-item px-24 py-12 d-flex align-items-start gap-3 mb-2 justify-content-between ${
                                  isClearing ? "fade-out" : ""
                                }`}
                              >
                                <div className="text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3">
                                  <span className="w-40-px h-40-px bg-warning-subtle text-info-main rounded-circle d-flex justify-content-center align-items-center flex-shrink-0">
                                    N
                                  </span>
                                  <div>
                                    <h6 className="text-sm fw-semibold mb-0">
                                      {notification.title}
                                    </h6>
                                    <p className="mb-0 text-sm text-secondary-light text-w-200-px">
                                      {notification.message}
                                    </p>
                                  </div>
                                </div>
                                <span className="text-xs text-secondary-light flex-shrink-0">
                                  {formatDateStringdot(notification.entry_date)}
                                </span>
                              </Link>
                            ))}
                          {reviewData.length > 0 &&
                            reviewData
                              .filter((notification) => {
                                const entryDate = new Date(
                                  notification.entry_date,
                                );
                                const today = new Date();
                                const diffInTime =
                                  today.getTime() - entryDate.getTime();
                                const diffInDays =
                                  diffInTime / (1000 * 3600 * 24);
                                return (
                                  diffInDays <= 20 &&
                                  notification.open_close === "0"
                                );
                              })
                              .map((notification, index) => (
                                <Link
                                  key={index}
                                  to={{
                                    pathname: "/Reviews",
                                  }}
                                  state={{ review_id: notification.bb_id }}
                                  className={`notification-item px-24 py-12 d-flex align-items-start gap-3 mb-2 justify-content-between ${
                                    isClearing ? "fade-out" : ""
                                  }`}
                                  onClick={() => handlenotifClick(notification)}
                                >
                                  <div className="text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3">
                                    <span className="w-40-px h-40-px bg-info-subtle text-info-main rounded-circle d-flex justify-content-center align-items-center flex-shrink-0">
                                      R
                                    </span>
                                    <div>
                                      <h6 className="text-sm fw-semibold mb-0">
                                        {notification.name_user} Left you a
                                        review at {notification.platform}
                                      </h6>
                                      <p className="mb-0 text-sm text-secondary-light text-w-200-px">
                                        {notification.msg}
                                      </p>
                                    </div>
                                  </div>
                                  <span className="text-xs text-secondary-light flex-shrink-0">
                                    {formatDateStringdot(
                                      notification.entry_date,
                                    )}
                                  </span>
                                </Link>
                              ))}
                          {ticketData.length > 0 &&
                            ticketData.map((notification, index) => (
                              <Link
                                key={index}
                                to={{
                                  pathname: "/Support",
                                }}
                                state={{
                                  tkt_id: notification.ticket_id,
                                  create: "Reply",
                                }}
                                className={`notification-item px-24 py-12 d-flex align-items-start gap-3 mb-2 justify-content-between ${
                                  isClearing ? "fade-out" : ""
                                }`}
                              >
                                <div className="text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3">
                                  <span className="w-40-px h-40-px bg-success-subtle text-info-main rounded-circle d-flex justify-content-center align-items-center flex-shrink-0">
                                    T
                                  </span>
                                  <div>
                                    <h6 className="text-sm fw-semibold mb-0">
                                      ##000{notification.ticket_id}
                                    </h6>
                                    <p className="mb-0 text-sm text-secondary-light text-w-200-px">
                                      {notification.detail_reply}
                                    </p>
                                  </div>
                                </div>
                                <span className="text-xs text-secondary-light flex-shrink-0">
                                  {formatDateStringdot(
                                    notification.ticket_entry_date,
                                  )}
                                </span>
                              </Link>
                            ))}
                        </>
                      ) : (
                        <p
                          className="text-center text-secondary-light"
                          style={{ fontSize: "16px" }}
                        >
                          No Notifications Here
                        </p>
                      )}
                    </div>
                    <div className="bottomBtnCLear">
                      <p className="clearBtns" onClick={clearNotifications}>
                        Clear Notifications
                      </p>
                    </div>
                  </div>
                  <div className="dropdown">
                    <button
                      className="d-flex justify-content-center align-items-center rounded-circle"
                      type="button"
                      data-bs-toggle="dropdown"
                    >
                      <img
                        src={user_image_path + user_image}
                        onError={(e) => (e.target.src = DumImg)}
                        alt="image_user"
                        className="w-40-px h-40-px object-fit-cover rounded-circle"
                      />
                    </button>
                    <div className="dropdown-menu to-top dropdown-menu-sm">
                      <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                        <div>
                          <h6 className="text-lg text-primary-light fw-semibold mb-2">
                            {final_full_name}
                          </h6>
                          <span className="text-secondary-light fw-medium text-sm">
                            Admin
                          </span>
                        </div>
                        <button type="button" className="hover-text-danger">
                          <Icon
                            icon="radix-icons:cross-1"
                            className="icon text-xl"
                          />
                        </button>
                      </div>
                      <ul className="to-top-list">
                        <li>
                          <Link
                            className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3"
                            onClick={() => handleLogoutClick()}
                          >
                            <Icon
                              icon="lucide:power"
                              className="icon text-xl"
                            />{" "}
                            Log Out
                          </Link>
                        </li>
                        <li>
                          <Link
                            className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3"
                            onClick={handleThemeToggle}
                          >
                            <button
                              type="button"
                              data-theme-toggle
                              className="w-30-px h-30-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center"
                            >
                              Toggle Theme
                            </button>
                            Toggle Theme
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* Profile dropdown end */}
                </div>
              </div>
            </div>
          </div>

          {/* dashboard-main-body */}
          <div
            className={`dashboard-main-body`}
            style={{ overflowY: "hidden", height: "calc(100vh - 72px)" }}
          >
            {children}
          </div>

          {/* Footer section */}
          <footer className="d-footer">
            <div className="row align-items-center justify-content-between">
              <div className="col-auto">
                <p className="mb-0 text-sm">
                  © 2026 Triosoft. All Rights Reserved.
                </p>
              </div>
              <div className="col-auto">
                <p className="mb-0 text-sm">
                  Design & Developed by{" "}
                  <a
                    href="https://www.triosoft.ai"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="text-primary-600 text-sm">Triosoft</span>
                  </a>
                </p>
              </div>
            </div>
          </footer>
        </main>
        <Modal
          show={showModal}
          onHide={closeModal}
          centered
          backdrop="static"
          dialogClassName="modal-2xl"
          scrollable
          className="modal_pricing_div"
        >
          <Modal.Header closeModal>
            <Modal.Title>
              <X
                size={25}
                onClick={() => DateCount > 0 && closeModal()}
                className="close_model_div_pricing"
              />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ position: "relative" }}>
            <div className="PricingDiv">
              <div className="pricingTOpHead">
                {DateCount > 0 && (
                  <div className="d-flex gap-1 align-items-center">
                    <img src={electricIcon} alt="electricIcon" />
                    <p>Pricing Plans</p>
                  </div>
                )}
                {DateCount > 0 ? (
                  <h1>Simple Plan for Build Business Like Yours</h1>
                ) : (
                  <div
                    style={{
                      padding: "15px",
                      borderRadius: "10px",

                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <AlertTriangle color="#d8000c" size={28} />
                    <h1 style={{ margin: 0 }}>
                      Your Plan has Expired. Please Upgrade to Continue
                    </h1>
                  </div>
                )}

                {/* Tabs for switching between Monthly and Yearly */}
                <div className="tabs">
                  <button
                    className={`tabButton ${
                      activeTab === "monthly" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("monthly")}
                  >
                    Monthly
                  </button>
                  <button
                    className={`tabButton ${
                      activeTab === "yearly" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("yearly")}
                  >
                    Annual <span className="freeText">(2 Month Free)</span>
                  </button>
                </div>
              </div>

              <div className="row margnClass">
                {pricingPlansnew.map((plan, index) => (
                  <div className="col-lg-4 col-md-6 col-sm-6 mt-3" key={index}>
                    <div
                      className={`DataprinceBox1 ${
                        plan.isSelected ? "selected" : ""
                      }`}
                    >
                      <img
                        src={planImages[plan.imgSrc] || "/placeholder.svg"}
                        alt={`Plan ${index + 1}`}
                      />
                      <h3>{plan.title}</h3>
                      <p>{plan.description}</p>
                      {plan.price && (
                        <h1>
                          {plan.price}
                          <span style={{ fontSize: "14px", color: "gray" }}>
                            /month{" "}
                            {selectedCountry === "india"
                              ? "(Including GST)"
                              : "(Excl. Tax)"}
                          </span>
                        </h1>
                      )}
                      {activeTab === "yearly" && index !== 2 && (
                        <p className="billedText">Billed Annually</p>
                      )}

                      <div className="amount">
                        <button
                          className={
                            plan.id_add === "0@@@0" ? "margin_55_top" : ""
                          }
                          disabled={plan.buttonText === "Current Plan"}
                          onClick={() =>
                            plan.id_add !== "0@@@0"
                              ? handlepayment(plan)
                              : handleNavigate()
                          }
                        >
                          {plan.buttonText}
                        </button>
                      </div>
                      <ul>
                        {plan.features.map((feature, featureIndex) => (
                          <div className="d-flex margnLabal" key={featureIndex}>
                            <img
                              src={goodmarkImg || "placeholder.svg"}
                              alt="Goodmark"
                              className="GreenMarkImng"
                            />
                            <label>
                              <strong>{feature.text}</strong>{" "}
                              {feature.additionalText}
                            </label>
                          </div>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </section>
    </MasterDataContext.Provider>
  );
};

export default MasterLayout;
